import { render } from "./EvaluationQuestionsListView.vue?vue&type=template&id=5c18b31a&scoped=true&ts=true"
import script from "./EvaluationQuestionsListView.vue?vue&type=script&lang=ts"
export * from "./EvaluationQuestionsListView.vue?vue&type=script&lang=ts"

import "./EvaluationQuestionsListView.vue?vue&type=style&index=0&id=5c18b31a&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c18b31a"]])

export default __exports__